import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    siteKey: String,
    buttonId: { type: String, default: "recaptcha-enabled-button" },
  }

  static targets = ["container"]

  connect() {
    // Keep the submit button disabled until Turnstile succeeds.
    this.disableButton()

    this.render()
    // If script is blocked (cookies/trackers), show the message.
    if (!window.turnstile?.render) {
      this.showAllowCookiesMessage()
      window.addEventListener("turnstile:loaded", this.render.bind(this), { once: true })
      this.ensureScriptLoaded()
    }
  }

  disconnect() {
    if (this.widgetId === undefined) return
    try {
      window.turnstile?.remove(this.widgetId)
    } catch (_) {
      // no-op
    }
  }

  render() {
    if (!window.turnstile?.render) return
    if (this.widgetId !== undefined) return
    if (!this.hasContainerTarget) return

    this.hideAllowCookiesMessage()

    this.widgetId = window.turnstile.render(this.containerTarget, {
      sitekey: this.siteKeyValue,
      callback: () => this.enableButton(),
      "expired-callback": () => this.disableButton(),
      "error-callback": () => this.disableButton(),
      theme: "light",

    })
  }

  enableButton() {
    const button = document.getElementById(this.buttonIdValue)
    if (button) button.removeAttribute("disabled")
  }

  disableButton() {
    const button = document.getElementById(this.buttonIdValue)
    if (button) button.setAttribute("disabled", "disabled")
  }

  showAllowCookiesMessage() {
    const el = document.getElementById("allow-cookies-message")
    if (el) el.style.display = "block"
  }

  hideAllowCookiesMessage() {
    const el = document.getElementById("allow-cookies-message")
    if (el) el.style.display = "none"
  }

  ensureScriptLoaded() {
    const existing = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')
    if (existing) {
      if (!existing.dataset.turnstileLoadListenerAttached) {
        existing.dataset.turnstileLoadListenerAttached = "true"
        existing.addEventListener("load", () => window.dispatchEvent(new Event("turnstile:loaded")))
      }
      return
    }

    if (window.__turnstileScriptLoading) return
    window.__turnstileScriptLoading = true

    const script = document.createElement("script")
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
    script.async = true
    script.defer = true
    script.onload = () => window.dispatchEvent(new Event("turnstile:loaded"))
    document.head.appendChild(script)
  }
}
